export default "__VITE_ASSET__DPrhqXgl__"